import { render } from "./EditMessagePage.vue?vue&type=template&id=82f5595a"
import script from "./EditMessagePage.vue?vue&type=script&lang=js"
export * from "./EditMessagePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__